$(document).on('turbolinks:load', function(){
  if ($('.nav-item.-search').length) {
    var searchForm = $('.nav-item.-search form');
    $(document).on('click', '.nav-link.-search-icon', function(e){
      e.preventDefault();
      e.stopPropagation();
      var searchInput = searchForm.find('.-search-input');
      if ($('.-search-input.d-none').length) {
        searchInput.removeClass('d-none').focus();
      } else {
        if(searchInput.val() != ''){
          searchForm.submit();
        }
        searchInput.addClass('d-none');
      }
    });

    $(document).on('keypress', '.nav-item.-search form .-search-input', function (e) {
      if(e.which === 13){
        searchForm.submit();
      }
    });
  }
});